/**
 * Page content from PROGRAM.md. Single source for copy.
 */
export const content = {
  title: "Workshare Relief Loan",
  intro: [
    "For employees who may need financial assistance during this period, Triple E RV has established a short-term Workshare Relief Loan Program.",
    "This program is intended to provide temporary support for employees who may experience financial strain while working reduced hours under Workshare.",
    "A low-interest loan of $1,000 is available to eligible employees.",
  ],
  loanDetails: [
    "The Workshare Relief Loan is available only to Triple E RV employees experiencing financial pressure during the Workshare period.",
    "Loans are offered at a 3% annual interest rate.",
    "Repayment will begin approximately 30 days after the loan is issued, through a $40 deduction per paycheque until the loan is fully repaid.",
    "Employees may make partial or full payments at any time without penalty.",
    "If an employee's employment with Triple E Canada Ltd. ends, the remaining loan balance will become due and payable.",
    "One loan per employee is permitted under this program.",
    "If approved, please allow 7–10 days for processing.",
  ],
  agreementNote:
    "After completing the application, employees will receive a loan agreement by email. The loan will be processed once the signed agreement has been returned.",
  applyHeading: "Apply Now",
  successMessage:
    "Your application has been received. You will be emailed a loan agreement to sign shortly. Your loan application will not be processed until it has been signed.",
  formLabels: {
    employeeFirstName: "Employee First Name",
    employeeLastName: "Employee Last Name",
    employeeEmail: "Employee Email Address",
    employeeNumber: "Employee #",
    streetAddress: "Street Address",
    city: "City",
    postalCode: "Postal Code",
    phoneNumber: "Phone Number",
  },
  submitButton: "Submit",
  errorMessage: "There was an error with your submission. Please try again.",
} as const;
